import React from 'react';
import Seo from '../components/global/Seo';

/**
 * Branded 404 page. Rendered by Base's catch-all for unknown URLs (and for
 * known-but-inaccessible routes in some states). It can mount either full-page
 * (logged out) or inside the authenticated app shell, so it uses minHeight
 * (not a hard 100vh) and fills the available space.
 */
class PageNotFound extends React.Component {
  goHome = () => {
    window.location.href = '/';
  };

  goBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  };

  render() {
    return (
      <div className="nf-page">
        <Seo title="Page Not Found" noindex />

        {/* soft brand backdrop */}
        <div className="nf-glow" />

        <div className="nf-card">
          <div className="nf-code" aria-hidden="true">
            404
          </div>
          <p className="nf-text">
            The page you&rsquo;re looking for doesn&rsquo;t exist or may have
            been moved. Let&rsquo;s get you back on track.
          </p>

          <div className="nf-actions">
            <button
              type="button"
              className="nf-btn nf-btn-primary"
              onClick={this.goHome}
            >
              Go to Homepage
            </button>
            <button
              type="button"
              className="nf-btn nf-btn-ghost"
              onClick={this.goBack}
            >
              Go Back
            </button>
          </div>
        </div>

        <style>{`
          .nf-page {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            width: 100%;
            box-sizing: border-box;
            padding: 24px;
            overflow: hidden;
            background: radial-gradient(1200px 600px at 50% -10%, #eaf0ff 0%, #f6f8fc 45%, #eef1f7 100%);
          }
          .nf-glow {
            position: absolute;
            top: -180px;
            left: 50%;
            transform: translateX(-50%);
            width: 620px;
            height: 620px;
            background: radial-gradient(circle, rgba(0,45,166,0.18) 0%, rgba(0,45,166,0) 70%);
            pointer-events: none;
          }
          .nf-card {
            position: relative;
            z-index: 1;
            text-align: center;
            max-width: 560px;
            width: 100%;
          }
          .nf-code {
            font-weight: 800;
            line-height: 1;
            font-size: clamp(96px, 22vw, 190px);
            letter-spacing: -0.04em;
            background: linear-gradient(135deg, #001665 0%, #002da6 55%, #7896ff 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            margin-bottom: 8px;
            user-select: none;
            margin-top:-150px;
          }
          .nf-text {
            font-size: clamp(14px, 2.2vw, 17px);
            line-height: 1.6;
            color: #64748b;
            margin: 0 auto 32px;
            max-width: 460px;
          }
          .nf-actions {
            display: flex;
            gap: 14px;
            justify-content: center;
            flex-wrap: wrap;
          }
          .nf-btn {
            appearance: none;
            border: none;
            cursor: pointer;
            min-height: 50px;
            padding: 0 28px;
            font-size: 15px;
            font-weight: 600;
            border-radius: 12px;
            transition: transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease;
          }
          .nf-btn-primary {
            color: #fff;
            background: linear-gradient(135deg, #001665 0%, #001a7a 50%, #002da6 100%);
            box-shadow: 0 8px 24px rgba(0, 22, 101, 0.35);
          }
          .nf-btn-primary:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(0, 22, 101, 0.45);
          }
          .nf-btn-primary:active { transform: translateY(0); }
          .nf-btn-ghost {
            color: #001a7a;
            background: #ffffff;
            border: 1.5px solid rgba(0, 26, 122, 0.25);
            box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
          }
          .nf-btn-ghost:hover {
            border-color: rgba(0, 26, 122, 0.5);
            background: #f8fafc;
          }
          @media (prefers-reduced-motion: reduce) {
            .nf-btn { transition: none; }
          }
        `}</style>
      </div>
    );
  }
}

export default PageNotFound;
